import { _plus } from '@/helpers/bigNumber'
export const getList = (state) => state.list

export const count = (state) => state.list.length

export const getArray = state => state.list

export const total = (state) => {
  let thirdPartyInvoices = state.list
  return thirdPartyInvoices.reduce((acc, k) => {
    return _plus(acc, k.amount)
  }, 0)
}
export const apificate = (state) => {
  return state.list.map(x => {
    return {
      date: x.date,
      invoiceId: x.invoiceId,
      provider: x.provider,
      amount: x.amount
    }
  })
}
